// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App{
  min-height: 100vh;
}

.container{
  max-width: 1200px;
  margin: auto;
  padding: 10px 10px;
}

header{
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  margin-bottom: 50px;
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: var(--box-shadow);
}

header .logo{
  display: flex;
  align-items: center;
}

header .logo img{
  max-width: 100px;
  cursor: pointer;
}

header .logo span{
  font-size: 22px;
  margin-left: 7px;
  cursor: pointer;
  color: #525252;
}

header .themeSelector span{
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  border: 1px solid #dfdfdf;
}

header .themeSelector .activeTheme{
  height: 30px;
  width: 30px;
}

.addTask {
  padding: 20px 15px;
  border-radius: 5px;
  background-color: #FFFFFF;
  max-width: 500px;
  margin: 20px auto;
  box-shadow: var(--box-shadow);
}

.addTask form{
  display: flex;
  gap: 7px;
}

.addTask form input{
  flex-grow: 1;
  padding: 5px 5px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  font-size: 18px;
}

.addTask form input:focus{
  outline: 0.5px solid #eaeaea;
}

.addTask form button{
  background-color: #03ba5c;
  color: #FFFFFF;
  border: none;
  padding: 5px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
}

.addTask form button:hover{
  background-color: #03b056;
}

.showTask{
  padding: 20px 15px;
  border-radius: 5px;
  background-color: #FFFFFF;
  margin: 20px auto;
  box-shadow: var(--box-shadow);
}

.showTask div.head{
  padding: 10px 0px 20px 0px;
  border-bottom: 1px solid #dfdfdf;
  display: flex;
  align-items: center;
}

.showTask div.head div{
  flex-grow: 1;
}

.showTask .title{
  font-size: 18px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}

.showTask .count{
  background-color: #dfdfdf;
  color: #525252;
  padding: 5px 10px;
  border-radius: 50%;
  margin-left: 10px;
  -webkit-user-select: none;
          user-select: none;
}

.showTask .clearAll{
  background-color: #0f6af3;
  color: #FFFFFF;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  border: 0px;
  font-size: 16px;
}

.showTask .clearAll:hover{
  background-color: #1061db;
}

.showTask ul{
  margin: 30px 5px 20px 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 15px;
}

.showTask li{
  padding: 15px 10px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  gap: 5px;
  width: 350px;
  box-shadow: var(--box-shadow);
  border-radius: 5px;
  border-left: 5px solid #1365dfaf;
}

.showTask li:hover{
  background-color: #f8f8f8;
}

.showTask li p{
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.showTask li .name{
  font-size: 18px;
  padding-bottom: 5px;
}

.showTask li .time{
  font-size: 12px;
  color: #737373;
}

.showTask i.bi-pencil-square{
  font-size: 18px;
  color: #1363DF;
  cursor: pointer;
}

.showTask i.bi-trash{
  font-size: 18px;
  color: #D82148;
  cursor: pointer;
}

@media only screen and (max-width: 800px) {
  .showTask li{
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".App{\n  min-height: 100vh;\n}\n\n.container{\n  max-width: 1200px;\n  margin: auto;\n  padding: 10px 10px;\n}\n\nheader{\n  min-height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px;\n  margin-bottom: 50px;\n  background-color: #FFFFFF;\n  border-radius: 5px;\n  box-shadow: var(--box-shadow);\n}\n\nheader .logo{\n  display: flex;\n  align-items: center;\n}\n\nheader .logo img{\n  max-width: 100px;\n  cursor: pointer;\n}\n\nheader .logo span{\n  font-size: 22px;\n  margin-left: 7px;\n  cursor: pointer;\n  color: #525252;\n}\n\nheader .themeSelector span{\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 5px;\n  cursor: pointer;\n  border: 1px solid #dfdfdf;\n}\n\nheader .themeSelector .activeTheme{\n  height: 30px;\n  width: 30px;\n}\n\n.addTask {\n  padding: 20px 15px;\n  border-radius: 5px;\n  background-color: #FFFFFF;\n  max-width: 500px;\n  margin: 20px auto;\n  box-shadow: var(--box-shadow);\n}\n\n.addTask form{\n  display: flex;\n  gap: 7px;\n}\n\n.addTask form input{\n  flex-grow: 1;\n  padding: 5px 5px;\n  border: 1px solid #eaeaea;\n  border-radius: 5px;\n  font-size: 18px;\n}\n\n.addTask form input:focus{\n  outline: 0.5px solid #eaeaea;\n}\n\n.addTask form button{\n  background-color: #03ba5c;\n  color: #FFFFFF;\n  border: none;\n  padding: 5px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.addTask form button:hover{\n  background-color: #03b056;\n}\n\n.showTask{\n  padding: 20px 15px;\n  border-radius: 5px;\n  background-color: #FFFFFF;\n  margin: 20px auto;\n  box-shadow: var(--box-shadow);\n}\n\n.showTask div.head{\n  padding: 10px 0px 20px 0px;\n  border-bottom: 1px solid #dfdfdf;\n  display: flex;\n  align-items: center;\n}\n\n.showTask div.head div{\n  flex-grow: 1;\n}\n\n.showTask .title{\n  font-size: 18px;\n  font-weight: 600;\n  user-select: none;\n}\n\n.showTask .count{\n  background-color: #dfdfdf;\n  color: #525252;\n  padding: 5px 10px;\n  border-radius: 50%;\n  margin-left: 10px;\n  user-select: none;\n}\n\n.showTask .clearAll{\n  background-color: #0f6af3;\n  color: #FFFFFF;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  border: 0px;\n  font-size: 16px;\n}\n\n.showTask .clearAll:hover{\n  background-color: #1061db;\n}\n\n.showTask ul{\n  margin: 30px 5px 20px 5px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.showTask li{\n  padding: 15px 10px;\n  border-bottom: 1px solid #e5e5e5;\n  display: flex;\n  gap: 5px;\n  width: 350px;\n  box-shadow: var(--box-shadow);\n  border-radius: 5px;\n  border-left: 5px solid #1365dfaf;\n}\n\n.showTask li:hover{\n  background-color: #f8f8f8;\n}\n\n.showTask li p{\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.showTask li .name{\n  font-size: 18px;\n  padding-bottom: 5px;\n}\n\n.showTask li .time{\n  font-size: 12px;\n  color: #737373;\n}\n\n.showTask i.bi-pencil-square{\n  font-size: 18px;\n  color: #1363DF;\n  cursor: pointer;\n}\n\n.showTask i.bi-trash{\n  font-size: 18px;\n  color: #D82148;\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 800px) {\n  .showTask li{\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
